import { render, staticRenderFns } from "./BookingList.vue?vue&type=template&id=203a0045"
import script from "./BookingList.vue?vue&type=script&lang=js"
export * from "./BookingList.vue?vue&type=script&lang=js"
import style0 from "./BookingList.vue?vue&type=style&index=0&id=203a0045&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports